import React, { useContext, useEffect, useState } from "react";
import { ProfileContext } from "../Context/ProfileContext";
import SmallHero from "../Components/SmallHero";
import StepNavigation from "./StepNavigation";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { doRequest } from "../utils/doRequest";
import { cryptedUserId } from "../utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";
import Header from "../Components/Header";

const editorConfiguration = {
  toolbar: [
    "bold",
    // 'italic'
  ],
};

export default function Exhibitor() {
  const { profile } = useContext(ProfileContext);
  const [ position, setPosition] = useState("");
  const [ description, setDescription] = useState("");
  const [ activeVChat, setActiveVchat] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
	let isSubscribed = true;
	if(isSubscribed) {
		setActiveVchat(profile.activatevideo);
		setPosition(profile.position);
		setDescription(profile.shortdesc);
	} 
	return () => {isSubscribed = false;}
  }, [])
  
  function handleNext() {
    doRequest('Server', '/api/v1/Frontend/user/updateUser','POST', 
      {
        "userid": cryptedUserId(),
        "step": 1,
        "fields": {
            "position": position,
            "shortdesc": description,
            "activatevideo": activeVChat ? 1:0
        }
      }, true, (err, data) => {
      if(data.success) {
        toast.success('User Updated Successfully', {hideProgressBar: false  });
        return navigate('/user-editor/matchmaking');
          }
      })
  }

  function handlePrev() {
    doRequest('Server', '/api/v1/Frontend/user/updateUser','POST', 
    {
      "userid": cryptedUserId(),
      "step": 1,
      "fields": {
          "position": position,
          "shortdesc": description,
          "activatevideo": activeVChat ? 1:0
      }
    }, true, (err, data) => {
    if(data.success) {
        toast.success('User Updated Successfully', {hideProgressBar: false  });
        return navigate('/user-editor/professional');
      }
    })
  }

  return (
    <div class="base-box scroll-box" id="page-top">
      <Header hideOptions={true} />

      <div class="base-item">
        <SmallHero />

        <main class="main-content">
          <StepNavigation />
          <section class="modul backend-editor step-3">
            <div class="form-box">
              <h3>Your Profile - Exhibitor Contact Data</h3>
              <p class="info-text">
                This information will be shown in your Company Space
              </p>

              <div class="form-row approval-box">
                <div class="field-item standard-radio">
                  <input
                    type="checkbox"
                    name="tx_user_edituser[video-chat-appointments]"
                    id="video-chat-appointments"
                    value="Activate Video Chat Appointments"
                    checked={activeVChat}
                    onChange={(e) => setActiveVchat(e.target.checked)}
                  />
                  <label for="video-chat-appointments">
                    Activate Video Chat Appointments
                  </label>
                  <span class="button info open-tooltip"></span>
                  <div class="tooltip">
                    Lorem Ipsum Dolor Sit amet. this is a Tooltiptext for
                    tooltipping.
                  </div>
                </div>
              </div>
			{activeVChat ? (
				<>
					<div class="form-row position-box" id="step3-position">
						<div class="field-item">
						<input
							type="text"
							id="exhibitor-position"
							placeholder=" "
							class="standard-field"
							value={position}
							onChange={(e) => setPosition(e.target.value)}
						/>
						<label class="field-label" for="exhibitor-position">
							Position
						</label>
						</div>
					</div>
					<div
						class="form-row short-description-box"
						id="step3-description"
					>
						<div class="field-item">
						<label class="block-label" for="editor">
							Short Description{" "}
							<span class="description">I am the right person for…</span>
						</label>

						<CKEditor
							editor={ClassicEditor}
							config={editorConfiguration}
							data={description}
							onBlur={(event, editor) => {
							setDescription(editor.getData());
							}}
						/>

						{/* <textarea id="editor" name="tx_user_edituser[editor]" >{profile.shortdesc}</textarea> */}
						</div>
					</div>
			  	</>
			  ): ''}

              <div class="button-box">
                <div class="field-item">
                  <button
                    class="button previous show-loader"
                    name="tx_user_edituser[saveStep3]"
                    value="prev"
                    onClick={handlePrev}
                  >
                    <span class="button-label">Previous</span>
                    <span class="icon-box">
                      <i class="icon"></i>
                    </span>
                  </button>
                </div>
                <div class="field-item">
                  <button
                    class="button call-to-action next show-loader"
                    value="next"
					          onClick={handleNext}
                  >
                    <span class="button-label">Next</span>
                    <span class="icon-box">
                      <i class="icon"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </div>
  );
}
